// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"EQ-z","smallCardRow":"FQ-z","largeCardRow":"GQ-z","productSearchRow":"HQ-z","curatedRow":"IQ-z"};